// extracted by mini-css-extract-plugin
module.exports = {"container":"TabProducts_container__kGGmx","products":"TabProducts_products__ofpLo","headerContainer":"TabProducts_headerContainer__OB6Z2","link":"TabProducts_link__8uyrf"};